import { useMutation } from "@tanstack/react-query";
import httpClient from "../httpClient";

export interface PricePayload {
  amount: number | string;
  corporate_subsidiary_id: number | string;
  payment_method_id: number | string;
  corporate_service_id: number | string;
}

export interface PriceResponse {
  amount: string;
  // Components of total_fees. Always sent; 0 when the fee does not apply,
  // and a zero component is hidden rather than shown as a zero line.
  instrument_fee: string;
  registration_fee: string;
  total_fees: string;
  total_amount: string;
  calculated_at: string | null;
}

export const usePriceMutation = ({ authorisation = "" }) => {
  return useMutation(async (payload: PricePayload) => {
    const response = await httpClient("payment/price", {
      authorisation,
    }).get<PriceResponse>({ ...payload });

    return response;
  });
};
